export const InvoiceStatusToString = {
    "CREATED": 'Created',
    "PROCESSED": 'Processed/Sent',
    "CURRENT": 'Current/Unpaid',
    "PAST_DUE": 'Past Due',
    "PAYMENT_RECEIVED": 'Payment Received',
}